export const MANUFACTURING_SUBLINE_FILTER_MODAL_EVENT = 'parts:modals:manufacturing-subline:filter';
export const MANUFACTURING_SUBLINE_FILTER_MODAL_OPEN = `${MANUFACTURING_SUBLINE_FILTER_MODAL_EVENT}:open`;
export const MANUFACTURING_SUBLINE_FILTER_MODAL_CLOSE = `${MANUFACTURING_SUBLINE_FILTER_MODAL_EVENT}:close`;
